import http from '@/assets/js/http';

// 获取用户钱包交易明细
export const getBalanceRecord = (data) => {
  return http.get('/v1/app/UserBalanceRecord', data);
}

// 获取消息
export const getUserMessage = (data) => {
  return http.get('/v1/app/UserMessage', data);
}

//删除消息
export const deleteUserMessage = (uuid) => {
  return http.delete(`/v1/app/UserMessage/${uuid}`);
}

//是否接受微信通知
export const weChatNotice = () => {
  return http.get('/v1/app/WechatNotice');
}

//获取用户通知配置
export const userNoticeConfig = () => {
  return http.get('/v1/app/UserNoticeConfig');
}

//修改用户通知配置
export const modifyUserNoticeConfig = (uuid, data) => {
  return http.put(`/v1/app/UserNoticeConfig/${uuid}`, data)
}

// 修改个人信息
export const modifyUserInfo = (data, obj) => {
  return http.put(`/v1/app/UserInfo/${data}`, obj)
}


